import React, {Component} from 'react';
import {Tooltip} from 'reactstrap';
import {withTranslation} from 'react-i18next';

class ToolTip extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };

  render() {
    const id = `Tooltip${this.props.id}`;
    return (
      <span>
        <span id={id}>{this.props.children}</span>
        <Tooltip
          isOpen={this.state.isOpen}
          toggle={this.toggle}
          delay={200}
          target={id}>
          {this.props.text}
        </Tooltip>
      </span>
    );
  }
}

export default withTranslation()(ToolTip);
